import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { apiInstance, Dispatch, GET_DATA_USERS, RootState } from 'shared';
import { columnsGridUsersDrAct } from '../helper/columnsGridUsersDrAct';
import Swal from 'sweetalert2';

export const UseFormAddUsersTfe = () => {

    const dispatch = useDispatch<Dispatch>();
    const { content, paramsUrl } = useSelector((state: RootState) => state.electronicDocuments);
    const { loading } = useSelector((rootState: RootState) => rootState.loading.models.linkDocument);
    const { userRoles } = useSelector((state: RootState) => state.optionsDropdowns);
    const [dataFields, setDataFields] = useState<any[]>([]);
    const [columns, setColumns] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [ rowSelected, setRowSelected ] = useState<number[]>([]);

    const handleChangeCheck = (event: React.ChangeEvent<HTMLInputElement>, id: number, row:any) => {
        if(event.target.checked){
            Swal.fire({
                title: 'Confirmar',
                text: "¿Deseas agregar el usuario?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, agregar',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                const selectedIndex = rowSelected.indexOf(id);
                let newSelected: number[] = [];
        
                if (selectedIndex === -1) {
                    newSelected = newSelected.concat(rowSelected, id);
                } else if (selectedIndex === 0) {
                    newSelected = newSelected.concat(rowSelected.slice(1));
                } else if (selectedIndex === rowSelected.length - 1) {
                    newSelected = newSelected.concat(rowSelected.slice(0, -1));
                } else if (selectedIndex > 0) {
                    newSelected = newSelected.concat(
                        rowSelected.slice(0, selectedIndex),
                        rowSelected.slice(selectedIndex + 1),
                    );
                }
                if (result.isConfirmed) {
                    apiInstance.post(`${GET_DATA_USERS}/create`, {
                        userId: row.id,
                        name: row.name,
                        email: row.email,
                    })
                    .then(() => {
                        setRowSelected(newSelected);
                    });
                }
            });
        }
    };

    useEffect(() => {
        dispatch.menuDrawer.changeSelectedIndex(6);
        // dispatch.electronicDocuments.getElectronicDocuments({}, `${GET_DATA_USERS}/list_users_ad/`);
        dispatch.electronicDocuments.getElectronicDocuments(paramsUrl, `${GET_DATA_USERS}/list_users_ad/`);
        return () => {
            dispatch.electronicDocuments.cleanState();
        }
    }, [])

    useEffect(() => {
        const columnsTransform:any[] = [
        ...columnsGridUsersDrAct(userRoles),
        ]
        setColumns(columnsTransform)
        setRowSelected(content?.filter((item:any) => item.existUser).map((item:any) => item.id) || [])
    }, [content, userRoles])

    return {
        rowSelected,
        columns,
        content,
        handleChangeCheck,
    }
}
